var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPremiumContributionCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.596 10.001c.96 0 1.667-.707 1.667-1.666 0-.96-.707-1.667-1.667-1.667-.959 0-1.666.707-1.666 1.667 0 .959.706 1.666 1.666 1.666z",
    fill: "#FF6C01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.166 3.332H3.833c-.92 0-1.667.7-1.667 1.563v10.208c0 .861.748 1.562 1.667 1.562h13.333c.92 0 1.667-.7 1.667-1.562V4.895c0-.862-.748-1.563-1.667-1.563zm0 11.667l-13.333-.01V5l13.333.009v9.99z",
    fill: "#FF6C01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.167 7.5H15.5v1.667h-3.333V7.5zM13 10.833h2.5V12.5H13v-1.667zm-1.308 2.114c0-1.145-1.397-2.322-3.096-2.322-1.7 0-3.096 1.177-3.096 2.322v.386h6.192v-.386z",
    fill: "#FF6C01"
  })));
}

export default SvgIconPremiumContributionCard;